interface EarnTopIconProps {
	width?: number | string;
	height?: number | string;
	alt?: string;
	classes?: string;
}

export const EarnTopIcon = ({width, classes, alt}: EarnTopIconProps) => {
	/*********************
	// #region Redux
	**********************/

	return (
		<img
		src={process.env.VITE_EARN_TOP_ICON}
		className={`${classes}`}
		width={width}
		alt={alt}
	/>
	);
};
